"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CumulusPointsStatus = void 0;
var CumulusPointsStatus;
(function (CumulusPointsStatus) {
    CumulusPointsStatus["CONFIRMED"] = "CONFIRMED";
    CumulusPointsStatus["PENDING"] = "PENDING";
    CumulusPointsStatus["RETRY"] = "RETRY";
})(CumulusPointsStatus || (exports.CumulusPointsStatus = CumulusPointsStatus = {}));
//# sourceMappingURL=cumulus.js.map